export const INFOR_SIGNIN = "INFOR_SIGNIN"
export const ERR_NOTIFI_SIGNUP = "ERR_NOTIFI_SIGNUP"
export const SUCCESS_NOTIFI_SIGNUP = "SUCCESS_NOTIFI_SIGNUP"